import React from 'react';
import { Box } from '@mui/material';
import Hyperspeed from './Hyperspeed';

const TruckAnimation3D = () => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        position: 'relative',
        minHeight: '500px',
      }}
    >
      <Hyperspeed
        effectOptions={{
          length: 400,
          roadWidth: 10,
          islandWidth: 2,
          lanesPerRoad: 4,
          fov: 90,
          fovSpeedUp: 150,
          speedUp: 2,
          carLightsFade: 0.6,
          totalSideLightSticks: 25,
          lightPairsPerRoadWay: 50,
          colors: {
            roadColor: 0x004F82,
            islandColor: 0x003955,
            background: 0x00324C,
            shoulderLines: 0xfbbf24,
            brokenLines: 0x0077B8,
            leftCars: [0xfbbf24, 0xf59e0b, 0xd97706],
            rightCars: [0x0077B8, 0x00ACEA, 0x4DB9FF],
            sticks: 0x00ACEA,
          },
        }}
      />
    </Box>
  );
};

export default TruckAnimation3D;
